import { Component, OnInit } from '@angular/core';
import { Role } from '../role';
import { ActivatedRoute } from '@angular/router';
import { RoleService } from '../role.service';
import { PermissionService } from '../../permissions/permission.service'
import { Location } from '@angular/common';
import { NgForm } from '@angular/forms';
import { Message } from 'primeng/primeng';

@Component({
  selector: 'app-role-crud',
  templateUrl: './role-crud.component.html',
  styleUrls: ['./role-crud.component.css'],
  providers: [
				RoleService,
				PermissionService
			 ]
})
export class RoleCrudComponent implements OnInit {

  id: any = null;
  roles: Role;
  msgs: Message[] = [];
  selectedPermissions: string[];
  button_caption: string ="Сохранить"
  button_icon: string ="fa fa-save";

  constructor(
				private roleService: RoleService,
				private location: Location,
				private permissionService: PermissionService,
				private activatedRoute: ActivatedRoute
			) { 

 	 activatedRoute.params.subscribe(params=>{this.id=params['id']});

   		  if(this.id){
   		  	this.roleService.getRoleById(this.id).subscribe(response=>{this.roles=response['data'];console.log(response);
   		 		this.button_caption="Редактировать";
				this.button_icon="fa fa-edit";
					
				this.permissionService.getPermission().subscribe(response=>{this.roles.permissions=response['data'].map(function(value: any){
						return {label:value.display_name, value: value.id};}); 
				})

				this.selectedPermissions=response['data']['permissions'].map(function(value: any){
					return value.id;
				  });
			  });	
			

			

			 }
			 

			 this.permissionService.getPermission().subscribe(response=>{this.roles.permissions=response['data'].map(function(value: any){
                return {label:value.display_name, value: value.id};
            }); })
	}

  ngOnInit() {

  	this.roles={
			id: "",
			name: "",
			display_name: "",
			description: "",
			permissions: "" 
  	}

  }
  backClicked() {
	this.location.back();
  }

  crud(form: NgForm):void{

   		  if(!this.id){
   		  		this.roleService.createRole(form.value)
   		  		.subscribe((data) => {this.msgs.push({severity:'success', summary:'Сообщение', detail: "Успешно добавлено"});console.log(data);});

   		  }else{
   		  	this.roleService.updateRole(form.value,this.id)
   		  		.subscribe((data) => {this.msgs.push({severity:'success', summary:'Сообщение', detail: "Успешно изменено"});console.log(data);});
   		  }



  }



}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/roles/role-crud/role-crud.component.ts